<template>
  <v-row class="mb-auto userstable" justify="center">
    <v-col cols="12">
      <search v-if="issearch" :items="headers" @querydata="querydata"></search>
      <v-data-table show-select @toggle-select-all="selectAll" :multi-sort="false" v-model="selected" item-key="Id"
        :headers="headers" :items="mainData" :items-per-page="limit" :options.sync="options"
        :server-items-length="countData" :loading="loading" class="elevation-1 text-no-wrap" show-group-by
        :footer-props="{ itemsPerPageText: '分页:', 'items-per-page-options':[10,20,30,50,100,-1] }">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>用户</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-btn small :color="issearch ? 'error' : 'success'" dark class="mr-2" @click="issearch = !issearch">
              <v-icon>{{issearch ? "mdi-magnify-close" : "mdi-magnify"}}</v-icon>
            </v-btn>
            <v-btn small color="warning" dark @click="delselect">
              删除 <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
            <v-dialog v-model="dialog" max-width="960px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <user-form ref="child" :model="formmode" :userData="userData" @submit="submit"></user-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.Status="{ item }">
          <v-switch color="success" class="d-inline-block ml-2" :loading="loading" v-model="item.Status"
            @click="activeStatus(item)"></v-switch>
          <span :class="item.Status ? 'success--text' : 'error--text'">{{ item.Status ? '正常' : '禁用' }}</span>
        </template>
        <template v-slot:item.Usersproer.Usertype="{ item }">
          <span
            :class="item.Usersproer.Usertype == 0 ? '' : 'font-weight-bold primary--text'">{{ item.Usersproer.Usertype == 0 ? '个人' : '企业' }}</span>
        </template>
        <template v-slot:item.Rolesp="{ item }">
          <span v-for="(role,index) in item.Rolesp" :key="index">
            {{ role.RoleName }}
          </span>
        </template>
        <template v-slot:item.Usersproer.Openid="{ item }">
          <span style="max-width: 56px;" class="d-inline-block text-truncate">{{ item.Usersproer.Openid }}</span>
        </template>
        <template v-slot:item.Usersproer.Imgyyzz="{ item }">
          <div v-if="item.Usersproer.Imgyyzz" class="d-flex">
            <v-img max-width="48" max-height="48" :src="$store.state.serverhosts + item.Usersproer.Imgyyzz"
              @click="viewImg(item.Usersproer.Imgyyzz)"></v-img>
          </div>
        </template>
        <!-- <template v-slot:item.Usersproer.Imgsfz1="{ item }">
          <div v-if="item.Usersproer.Imgsfz1" class="d-flex">
            <v-img max-width="48" max-height="48" :src="$store.state.serverhosts + item.Usersproer.Imgsfz1"
              @click="viewImg(item.Usersproer.Imgsfz1)"></v-img>
          </div>
        </template>
        <template v-slot:item.Usersproer.Imgsfz2="{ item }">
          <div v-if="item.Usersproer.Imgsfz2" class="d-flex">
            <v-img max-width="48" max-height="48" :src="$store.state.serverhosts + item.Usersproer.Imgsfz2"
              @click="viewImg(item.Usersproer.Imgsfz2)"></v-img>
          </div>
        </template> -->
        <template v-slot:item.Usersproer.Zjpic="{ item }">
          <div v-if="item.Usersproer.Zjpic" class="d-flex">
            <v-img max-width="48" max-height="48" :src="'data:image/jpeg;base64,' + item.Usersproer.Zjpic"
              @click="viewBase64('data:image/jpeg;base64,' + item.Usersproer.Zjpic)"></v-img>
          </div>
        </template>
        <template v-slot:item.Usersproer.Zjtype="{ item }">
          <div class="d-flex">
            {{item.Usersproer.Zjtype == ' '?'身份证':item.Usersproer.Zjtype == 'I'?'外国人居住证':item.Usersproer.Zjtype == 'J'?'港澳台居住证':'未知'}}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="warning" class="mr-4" @click="reSetPassword(item)">mdi-lock-open-check
              </v-icon>
            </template>
            <span>重置密码</span>
          </v-tooltip>
          <v-icon color="info" class="mr-4" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">刷新数据</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
  import search from "@/components/search";
  import userForm from "@/components/userForm";
  export default {
    components: {
      search,
      userForm,
    },
    data: function () {
      return {
        dialog: false,
        selected: [],
        headers: [
          {
            text: "用户名",
            value: "Username",
            fixed: true,
            groupable: false,
          },
          {
            text: "状态",
            value: "Status",
            groupable: false
          },
          {
            text: "Email",
            value: "Email",
            groupable: false
          },
          // {
          //   text: "注册IP",
          //   value: "CreateIp",
          //   groupable: false
          // },
          // {
          //   text: "登录时间",
          //   value: "LastTime",
          //   groupable: false
          // },
          // {
          //   text: "登录IP",
          //   value: "LastIp",
          //   groupable: false
          // },
          // {
          //   text: "角色",
          //   value: "Rolesp",
          //   sortable: false,
          // },
          // {
          //   text: "Openid",
          //   value: "Usersproer.Openid",
          //   groupable: false
          // },
          {
            text: "类型",
            value: "Usersproer.Usertype",
            groupable: false
          },
          {
            text: "单位名称",
            value: "Usersproer.Name",
            groupable: false
          },
          {
            text: "统一社会信用代码",
            value: "Usersproer.Code",
            groupable: false
          },
          {
            text: "法人",
            value: "Usersproer.Faren",
            groupable: false
          },
          {
            text: "电话",
            value: "Usersproer.Phone",
            groupable: false
          },
          {
            text: "生产地址",
            value: "Usersproer.Addr",
            groupable: false
          },
          {
            text: "营业执照",
            value: "Usersproer.Imgyyzz",
            groupable: false
          },
          // {
          //   text: "身份证正面",
          //   value: "Usersproer.Imgsfz1",
          //   groupable: false
          // },
          // {
          //   text: "身份证背面",
          //   value: "Usersproer.Imgsfz2",
          //   groupable: false
          // },
          { text: "证件号", value: "Usersproer.Zjnum", groupable: false },
          { text: "证件地址", value: "Usersproer.Zjaddr", groupable: false },
          { text: "证件签发机关", value: "Usersproer.Zjorg", groupable: false },
          { text: "证件类型", value: "Usersproer.Zjtype", groupable: false },
          { text: "证件起始有效时间", value: "Usersproer.Zjtimestart", groupable: false },
          { text: "证件截止有效时间", value: "Usersproer.Zjtimeend", groupable: false },
          { text: "证件性别", value: "Usersproer.Zjgender", groupable: false },
          { text: "证件照片", value: "Usersproer.Zjpic", groupable: false },
          { text: "证件民族", value: "Usersproer.Zjnation", groupable: false },
          { text: "证件姓名", value: "Usersproer.Zjname", groupable: false },
          // {
          //   text: "创建时间",
          //   value: "CreateAt",
          //   groupable: false
          // },
          // {
          //   text: "更新时间",
          //   value: "UpdateAt",
          //   groupable: false
          // },
          {
            text: "操作",
            value: "actions",
            sortable: false,
            groupable: false
          }
        ],
        issearch: false,
        mainData: [],
        countData: 0,
        offset: 0,
        limit: this.$store.state.glimit,
        query: "",
        exclude: "",
        sortby: "",
        order: "",
        options: {},
        loading: false,
        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        userData: {},
        formmode: 'admin-add',
      }
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "新增" : "编辑";
      }
    },
    watch: {
      dialog(val) {
        val || this.close()
      },
      options: {
        handler() {
          this.limit = this.options.itemsPerPage;
          this.offset = (this.options.page - 1) * this.limit;
          this.sortby = "";
          this.order = "";
          for (let index = 0; index < this.options.sortBy.length; index++) {
            this.sortby += this.options.sortBy[index] + ",";
            this.order += this.options.sortDesc[index] ? "desc," : "asc,";
          }
          if (this.sortby.length > 0) {
            this.sortby = this.sortby.slice(0, -1);
            this.order = this.order.slice(0, -1);
          } else {
            this.sortby = "Id";
            this.order = "desc";
          }
          this.initialize();
        },
        deep: true
      }
    },
    methods: {
      submit(data) {
        if (data) {
          this.save(data)
        } else {
          this.dialog = false
        }
      },
      viewBase64(src){
        this.$store.commit("setviewimg", src);
      },
      viewImg(src) {
        this.$store.commit("setviewimg", this.$store.state.serverhosts + src);
      },
      querydata(query, exclude) {
        this.query = query;
        this.exclude = exclude;
        this.initialize();
      },
      selectAll(item) {
        this.selected = item.value ? item.items : [];
      },
      delselect(e) {
        if (!confirm("确认删除所有选中项吗?")) return;
        if (this.selected.length > 0) {
          let ids = "";
          let arrid = [];
          for (let index = 0; index < this.selected.length; index++) {
            ids += this.selected[index].Id + ",";
            arrid.push(this.selected[index].Id);
          }
          if (ids.length > 0) {
            ids = ids.slice(0, -1);
          }
          this.loading = true
          this.$api.delUser({
            id: ids
          }).then(res => {
            this.loading = false
            for (let index = 0; index < arrid.length; index++) {
              this.mainData = this.mainData.filter(
                item => item.Id != arrid[index]
              );
            }
            this.countData -= arrid.length;
          }).catch(error => {
            this.loading = false
            let message = (error && error.msg) || "删除选中选失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        } else {
          this.$store.commit("setsnack", { message: "尚未选择任何项目", color: "warning" });
        }
      },
      initialize() {
        this.loading = true;
        let data = {
          limit: this.limit,
          offset: this.offset
        };
        if (this.query != "") {
          data.query = this.query;
        }
        if (this.exclude != "") {
          data.exclude = this.exclude;
        }
        if (this.sortby != "") {
          data.sortby = this.sortby;
          data.order = this.order;
        }
        data.fields = 'Id,Email,Status,Username,Usersproer'
        this.$api.getUsers(data).then(res => {
          this.loading = false;
          if (res.data) {
            this.mainData = res.data;
            this.countData = res.count;
          } else {
            this.mainData = [];
            this.countData = 0;
          }
        }).catch(error => {
          this.loading = false;
          let message = (error && error.msg) || "获取数据列表失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      },
      activeStatus(item) {
        this.loading = true
        this.$api.setUserStatus({ Id: item.Id, Status: item.Status }).then(res => {
          this.loading = false;
        }).catch(error => {
          this.loading = false;
          item.Status = !item.Status
          let message = (error && error.msg) || "改变用户状态失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      },
      reSetPassword(item) {
        let password = '123456'
        if (!confirm(`确认要将该用户的密码重置为 ${password} 吗?`)) return;
        this.loading = true
        this.$api.reSetPassword({ Id: item.Id, Password: password }).then(res => {
          this.loading = false;
          this.$store.commit("setsnack", {
            message: '用户密码已重置为' + password,
            color: 'success'
          });
        }).catch(error => {
          this.loading = false;
          let message = (error && error.msg) || "重置密码失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      },
      editItem(item) {
        this.editedIndex = this.mainData.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.userData = Object.assign({}, item);
        this.formmode = 'admin-edit'
        this.dialog = true;
      },
      deleteItem(item) {
        const index = this.mainData.indexOf(item);
        if (confirm("确认删除此项数据吗?")) {
          // Del Item
          const data = {
            id: item.Id
          };
          this.loading = true
          this.$api.delUser(data).then(res => {
            this.loading = false
            this.mainData.splice(index, 1);
            this.countData--;
          }).catch(error => {
            this.loading = false
            let message = (error && error.msg) || "删除失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        }
      },
      close() {
        this.userData = {}
        this.formmode = 'admin-add'
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save(data) {
        delete data.Add
        delete data.Del
        delete data.Rolesp
        this.editedItem = JSON.parse(JSON.stringify(data))
        delete this.editedItem.NewPassword
        delete this.editedItem.OldPassword

        this.editedItem.UpdateAt = this.$utils.formatDate(
          new Date(),
          "yyyy-MM-dd hh:mm:ss"
        );
        this.loading = true;
        if (this.editedIndex > -1) {
          this.$api.editUserAdmin(data).then(res => {
            this.loading = false;
            Object.assign(this.mainData[this.editedIndex], this.editedItem);
            this.close();
          }).catch(error => {
            this.loading = false;
            let message = (error && error.msg) || "编辑失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        } else {
          this.$store.commit("setsnack", { message: '无法直接添加用户，请退出后注册用户！' });
        }
      }
    }
  };
</script>